import { action, makeObservable, observable } from 'mobx';


class AutoBetStore {
  autoBetModel = null;
  isPlay = false;

  constructor() {
    makeObservable(this, {
      isPlay: observable,
      resetAutoBet: action.bound,
      setIsPlay: action.bound,
      autoBetModel: observable.deep,
      setAutoBetModel: action.bound,
      setAutoBetCount: action.bound,
    });
  }

  resetAutoBet() {
    this.isPlay = false;
    this.autoBetModel = null;
  }

  setIsPlay(isPlay) {
    if (!isPlay) {
      this.autoBetModel = null;
    }
    this.isPlay = isPlay;
  }

  setAutoBetModel(payload) {
    this.autoBetModel = payload;
  }

  setAutoBetCount() {
    this.autoBetModel = {
      ...this.autoBetModel,
      autoBetCount: this.autoBetModel.autoBetCount - 1,
    };
  }

}

export const autoBetStore = new AutoBetStore();
